import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3dbaab44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "巡查模板", -1))
const _hoisted_3 = { style: {"margin-left":"auto"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "点检问题", -1))
const _hoisted_5 = { style: {"margin-left":"auto"} }
const _hoisted_6 = { class: "uni-form-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "是否需要整改", -1))
const _hoisted_8 = { style: {"margin-left":"auto"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "整改人", -1))
const _hoisted_10 = { style: {"margin-left":"auto"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "一级审核人", -1))
const _hoisted_12 = { style: {"margin-left":"auto"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "二级审核人", -1))
const _hoisted_14 = { style: {"margin-left":"auto"} }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "三级审核人", -1))
const _hoisted_16 = { style: {"margin-left":"auto"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "整改截至时间", -1))
const _hoisted_18 = { style: {"margin-left":"auto"} }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "抄送人", -1))
const _hoisted_20 = { style: {"margin-left":"auto"} }
const _hoisted_21 = { class: "uni-btn-v" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("提交任务")

import { ref } from 'vue'
import PatrolTemplate from '@/components/PatrolTemplate/index.vue'
import QuestionSelect from '@/components/QuestionSelect/index.vue'
import PersonnelSelect from '@/components/PersonnelSelect/index.vue'
import {
  ITemplateName,
  IQuestion,
  IRetrospect,
  IPersonnel
} from '@/utils/interface'
import { Toast } from 'vant'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { getWarningById, recordActionSubmit } from '@/api/shop'
import dayjs from 'dayjs'
import ComHeader from '@/components/ComHeader/index.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const currentDate = ref<null | Date>(null)
const showPicker = ref(false)
const switchFlag = ref(false)
const show = ref(false)
const questionFlag = ref(false)
const personnelFlag = ref(false)
const checkedList = ref<IQuestion[]>([])
const route = useRoute()
const router = useRouter()
const auditPersonLevel = ref(0)
const comments = ref('')
const data = ref<IRetrospect>()
const personnelType = ref('1')
const loading = ref(false)
const personnelIndex = ref(0)
const personData = ref<IPersonnel[]>([])

const store = useStore()

const formSubmit = () => {
  if (!curTemp.value?.templateId) {
    Toast.fail('请选择模板')
    return
  }
  if (!checkedList.value.length) {
    Toast.fail('请选择问题')
    return
  }
  if (switchFlag.value && !currentDate.value) {
    Toast.fail('请选择整改到期日期')
    return
  }
  if (switchFlag.value && !comments.value) {
    Toast.fail('请填写整改意见')
    return
  }
  if (switchFlag.value && !rectifyUserIds.value?.length) {
    Toast.fail('请选择整改人')
    return
  }
  if (switchFlag.value && !auditUserArrayList.value?.length) {
    Toast.fail('请选择审核人')
    return
  }

  if (
    auditPersonLevel.value > 0 &&
    switchFlag.value &&
    auditUserArrayList.value?.length &&
    !auditUserArrayList.value[0]?.length
  ) {
    Toast.fail('请选择一级审核人')
    return
  }
  if (
    auditPersonLevel.value > 1 &&
    switchFlag.value &&
    auditUserArrayList.value?.length &&
    !auditUserArrayList.value[1]?.length
  ) {
    Toast.fail('请选择二级审核人')
    return
  }
  if (
    auditPersonLevel.value > 2 &&
    switchFlag.value &&
    auditUserArrayList.value?.length &&
    !auditUserArrayList.value[2]?.length
  ) {
    Toast.fail('请选择三级审核人')
    return
  }
  loading.value = true
  try {
    recordActionSubmit({
      thirdTenantId: store.getters.thirdTenantId,
      templateId: curTemp.value?.templateId,
      templateName: curTemp.value?.templateName,
      exceptionId: data.value?.exceptionId,
      rectifyDeadline: currentDate.value
        ? dayjs(currentDate.value).format('YYYY-MM-DD HH:mm:ss')
        : null,
      auditPersonLevel: auditPersonLevel.value,
      storeNo: data.value?.storeNo,
      isRecord: switchFlag.value ? 1 : 0,
      comments: comments.value,
      groupInfoList,
      rectifyUserIds: rectifyUserIds.value
        .map((item: IPersonnel) => item.userId)
        .join(','),
      copyUserIds: copyUserIds.value
        .map((item: IPersonnel) => item.userId)
        .join(','),
      auditUserArrayList: auditUserArrayList.value.map((item: IPersonnel[]) =>
        item.map((item2: IPersonnel) => item2.userId)
      )
    }).then((res: any) => {
      if (res?.recordId) {
        Toast.success('提交成功')
        setTimeout(() => {
          router.back()
        }, 500)
      }
    })
  } finally {
    loading.value = false
  }
}

const showDate = () => {
  if (!currentDate.value) {
    currentDate.value = new Date()
  }
  showPicker.value = true
}

getWarningById({
  id: route.query.id
}).then((res: any) => {
  data.value = res
})

let groupInfoList: any
const questionChange = (arr: IQuestion[], level: number, list: any) => {
  questionFlag.value = false
  checkedList.value = arr
  auditPersonLevel.value = level
  groupInfoList = list
  rect('ques')
}

const auditUserArrayList: any = ref<IPersonnel[][]>([])
const copyUserIds = ref<IPersonnel[]>([])
const rectifyUserIds = ref<IPersonnel[]>([])
const personChange = (type: string, persons: IPersonnel[], index: number) => {
  if (type === '2') {
    auditUserArrayList.value[index] = persons
  } else if (type === '3') {
    copyUserIds.value = persons
  } else {
    rectifyUserIds.value = persons
  }
  personnelFlag.value = false
}

const showQuestion = () => {
  if (!curTemp.value) {
    Toast.fail('请先选择模板')
    return
  }
  questionFlag.value = true
}

const curTemp = ref<ITemplateName | null>(null)
const customChange = (temp: ITemplateName) => {
  show.value = false
  curTemp.value = temp

  rect('temp')
}

const showPerson = (type: string, index?: number) => {
  if (!curTemp.value?.templateId) {
    Toast.fail('请先选择模板')
    return
  }
  personnelType.value = type
  personnelFlag.value = true
  if (type === '1') {
    personData.value = JSON.parse(JSON.stringify(rectifyUserIds.value))
  } else if (type === '2') {
    if (index === 1) {
      personData.value = JSON.parse(
        JSON.stringify(
          auditUserArrayList.value[1] ? auditUserArrayList.value[1] : []
        )
      )
    } else if (index === 2) {
      personData.value = JSON.parse(
        JSON.stringify(
          auditUserArrayList.value[2] ? auditUserArrayList.value[2] : []
        )
      )
    } else {
      personData.value = JSON.parse(
        JSON.stringify(
          auditUserArrayList.value[0] ? auditUserArrayList.value[0] : []
        )
      )
    }
  } else {
    personData.value = JSON.parse(JSON.stringify(copyUserIds.value))
  }
  if (index !== undefined) {
    personnelIndex.value = index
  }
}

const switchChange = (e: boolean) => {
  if (e && !auditPersonLevel.value) {
    Toast.fail('请选择点检问题')
    switchFlag.value = false
  }
  if (e && !curTemp.value?.templateId) {
    Toast.fail('请选择点巡查模板')
    switchFlag.value = false
  }
  if (!e) {
    currentDate.value = null
    rectifyUserIds.value = []
    auditUserArrayList.value = []
  }
}

const rect = (type: string) => {
  switchFlag.value = false
  auditUserArrayList.value = []
  copyUserIds.value = []
  rectifyUserIds.value = []
  personData.value = []
  personnelIndex.value = 0
  personnelType.value = '1'
  if (type === 'temp') {
    auditPersonLevel.value = 0
    checkedList.value = []
  }
}

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_switch = _resolveComponent("van-switch")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ComHeader, {
      height: 16,
      title: "生成任务"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", null, [
        _createElementVNode("div", {
          class: "uni-form-item",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (show.value = true))
        }, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, _toDisplayString(curTemp.value?.templateName), 1),
          _createVNode(_component_van_icon, {
            name: "arrow",
            size: "20",
            color: "#ccc"
          })
        ]),
        _createElementVNode("div", {
          class: "uni-form-item",
          onClick: showQuestion
        }, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, _toDisplayString(checkedList.value.length
              ? `问题项：${checkedList.value.length}项，得分：${checkedList.value
                  .map((item) => item.score)
                  .reduce((a, b) => a + b)}分`
              : ''), 1),
          _createVNode(_component_van_icon, {
            name: "arrow",
            size: "20",
            color: "#ccc"
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_van_switch, {
              modelValue: switchFlag.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((switchFlag).value = $event)),
              name: "switch",
              onChange: switchChange,
              checked: "",
              "active-color": "#FD6304",
              size: "20",
              style: {"margin-top":"-4px"}
            }, null, 8, ["modelValue"])
          ])
        ]),
        (switchFlag.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "uni-form-item",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (showPerson('1')))
            }, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, _toDisplayString(rectifyUserIds.value.length
            ? `${rectifyUserIds.value.map((item) => item.nickname).join('，')}`
            : ''), 1),
              _createVNode(_component_van_icon, {
                name: "arrow",
                size: "20",
                color: "#ccc"
              })
            ]))
          : _createCommentVNode("", true),
        (switchFlag.value && auditPersonLevel.value > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "uni-form-item",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (showPerson('2', 0)))
            }, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, _toDisplayString(auditUserArrayList.value[0]
              ? auditUserArrayList.value[0].map((item) => item.nickname).join('，')
              : ''), 1),
              _createVNode(_component_van_icon, {
                name: "arrow",
                size: "20",
                color: "#ccc"
              })
            ]))
          : _createCommentVNode("", true),
        (switchFlag.value && auditPersonLevel.value > 1)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "uni-form-item",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (showPerson('2', 1)))
            }, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, _toDisplayString(auditUserArrayList.value[1]
              ? auditUserArrayList.value[1].map((item) => item.nickname).join('，')
              : ''), 1),
              _createVNode(_component_van_icon, {
                name: "arrow",
                size: "20",
                color: "#ccc"
              })
            ]))
          : _createCommentVNode("", true),
        (switchFlag.value && auditPersonLevel.value > 2)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: "uni-form-item",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (showPerson('2', 2)))
            }, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, _toDisplayString(auditUserArrayList.value[2]
              ? auditUserArrayList.value[2].map((item) => item.nickname).join('，')
              : ''), 1),
              _createVNode(_component_van_icon, {
                name: "arrow",
                size: "20",
                color: "#ccc"
              })
            ]))
          : _createCommentVNode("", true),
        (switchFlag.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 4,
              class: "uni-form-item",
              onClick: showDate,
              style: {"border":"none"}
            }, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, _toDisplayString(currentDate.value ? _unref(dayjs)(currentDate.value).format('YYYY-MM-DD HH:mm:ss') : ''), 1),
              _createVNode(_component_van_icon, {
                name: "arrow",
                size: "20",
                color: "#ccc"
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "uni-form-item",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (showPerson('3'))),
          style: {"border-bottom":"16px solid rgb(252, 252, 252)","border-top":"16px solid rgb(252, 252, 252)"}
        }, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, _toDisplayString(copyUserIds.value.length
              ? `${copyUserIds.value.map((item) => item.nickname).join('，')}`
              : ''), 1),
          _createVNode(_component_van_icon, {
            name: "arrow",
            size: "20",
            color: "#ccc"
          })
        ]),
        _createVNode(_component_van_image, {
          style: {"width":"94%","margin":"0 3% 14px","height":"200px"},
          mode: "scaleToFill",
          src: data.value?.imageUrl
        }, null, 8, ["src"]),
        _createVNode(_component_van_cell_group, null, {
          default: _withCtx(() => [
            _createVNode(_component_van_field, {
              modelValue: comments.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((comments).value = $event)),
              rows: "5",
              autosize: "",
              label: "整改意见",
              type: "textarea",
              maxlength: "300",
              placeholder: "请输入整改意见",
              "show-word-limit": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_van_button, {
            loading: loading.value,
            onClick: formSubmit,
            block: "",
            class: "com-button"
          }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _createVNode(_component_van_popup, {
          show: showPicker.value,
          "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => ((showPicker).value = $event)),
          round: "",
          position: "bottom"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_datetime_picker, {
              modelValue: currentDate.value,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((currentDate).value = $event)),
              type: "datetime",
              title: "选择完整时间",
              onCancel: _cache[9] || (_cache[9] = ($event: any) => (showPicker.value = false)),
              onConfirm: _cache[10] || (_cache[10] = ($event: any) => (showPicker.value = false))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["show"]),
        _createVNode(_component_van_popup, {
          show: show.value,
          "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => ((show).value = $event)),
          round: "",
          closeable: "",
          position: "bottom",
          style: { height: '50%' }
        }, {
          default: _withCtx(() => [
            _createVNode(PatrolTemplate, { onCustomChange: customChange })
          ]),
          _: 1
        }, 8, ["show"]),
        _createVNode(_component_van_popup, {
          show: questionFlag.value,
          "onUpdate:show": _cache[13] || (_cache[13] = ($event: any) => ((questionFlag).value = $event)),
          round: "",
          closeable: "",
          position: "bottom",
          style: { height: '90%' }
        }, {
          default: _withCtx(() => [
            _createVNode(QuestionSelect, {
              templateId: curTemp.value?.templateId,
              onSaveData: questionChange,
              checkedList: checkedList.value
            }, null, 8, ["templateId", "checkedList"])
          ]),
          _: 1
        }, 8, ["show"]),
        _createVNode(_component_van_popup, {
          show: personnelFlag.value,
          "onUpdate:show": _cache[14] || (_cache[14] = ($event: any) => ((personnelFlag).value = $event)),
          round: "",
          closeable: "",
          position: "bottom",
          style: { height: '90%' }
        }, {
          default: _withCtx(() => [
            _createVNode(PersonnelSelect, {
              flag: personnelFlag.value,
              data: personData.value,
              templateId: curTemp.value?.templateId,
              storeNo: data.value?.storeNo,
              type: personnelType.value,
              indexs: personnelIndex.value,
              onPersonChange: personChange
            }, null, 8, ["flag", "data", "templateId", "storeNo", "type", "indexs"])
          ]),
          _: 1
        }, 8, ["show"])
      ])
    ])
  ], 64))
}
}

})